import React, { useState } from 'react';
import { TeamRole, useAuthenticationContextRequired, useLlmConsentService, LLM_CONSENT_UPDATED } from 'nekst-api';
import { useEventsPublisher } from 'event-bus';
import nekstAiIcon from './nekstAiIcon.png';
import styles from '../ChatWidget.module.scss';

function isOwnerOrAdmin(role: TeamRole): boolean {
  return role === TeamRole.OWNER || role === TeamRole.ADMINISTRATOR;
}

function AdminConsentContent() {
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const consentService = useLlmConsentService();
  const eventsPublisher = useEventsPublisher();

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await consentService.giveConsent();
      eventsPublisher.publish(LLM_CONSENT_UPDATED, {});
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <p>
        Nekst AI uses third-party AI providers to process your requests.
        Information you share in this chat, including transaction details
        and contact information, may be sent to these providers for processing.
      </p>
      <label className={styles.consentCheckboxRow}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
        />
        <span>I understand and want to use Nekst AI</span>
      </label>
      <button
        type="button"
        className={styles.consentButton}
        disabled={!isChecked || isSubmitting}
        onClick={handleSubmit}
      >
        {isSubmitting ? 'Enabling...' : 'Continue'}
      </button>
    </>
  );
}

function MemberConsentContent() {
  return (
    <>
      <p>
        Nekst AI uses third-party AI providers to process your requests.
        Information you share in this chat, including transaction details
        and contact information, may be sent to these providers for processing.
      </p>
      <p className={styles.consentMemberNote}>
        Your team administrator needs to enable Nekst AI before you can use it.
      </p>
    </>
  );
}

export default function ConsentBubble() {
  const { user } = useAuthenticationContextRequired();
  const canConsent = isOwnerOrAdmin(user.teamRole);

  return (
    <div className={`${styles.messageRow} ${styles.messageRowAssistant}`}>
      <div className={styles.bubbleAvatar}>
        <img src={nekstAiIcon} alt="Nekst AI" width={28} height={28} />
      </div>
      <div className={styles.bubbleWrapper}>
        <div className={styles.bubbleMeta}>
          <span className={styles.bubbleSender}>Nekst AI</span>
        </div>
        <div className={`${styles.assistantBubble} ${styles.consentBubble}`}>
          <p><strong>Before you use Nekst AI</strong></p>
          {canConsent ? <AdminConsentContent /> : <MemberConsentContent />}
        </div>
      </div>
    </div>
  );
}
